import moment from 'moment';
import 'moment-timezone';
export default {
    install(app) {
        moment.locale('ru');
        moment.tz.setDefault('Asia/Dushanbe');
        app.config.globalProperties.$moment = moment;
    }
};
